export default __webpack_public_path__ + "static/siteScreen-d2ba7a9d5d62c6d735e9815867c8fdd6.jpg";